import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import CargoPageContent from "./CargoPageContent";
import { CargoPageHeading } from "./CargoPageHeading";
import { CargoNextPage } from "./CargoNextPage";
export const Cargo = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "cargoPageHeading",
      children: <CargoPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "cargoPageContent",
      children: <CargoPageContent/>
    },
    {
      label: "Next Page",
      key: "cargoNextPage",
      children: <CargoNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
